import React from 'react';

import { ContractManagementRegistrationAccess } from '@forvalter/routing/Routes';
import { ContractManagementSummaryView } from '@klp/contractregistration';
import { IconName } from '@klp/design/Illustrations';
import ProsjektSummaryView from '@klp/prosjekt/components/ProsjektSummaryView';
import SakSummaryView from '@klp/sak/SakSummaryView';
import type { Bruker } from '@klp/user';
import { UtestaaendeFordringerSummary } from '@klp/utestaaendefordringer';

import { FrontpageCardTypes } from '../utils';
import { ArealmessigUtleiegradSummary } from './ArealmessigUtleiegradSummary';
import LeverandorSummaryView from '@klp/leverandor/components/LeverandorSummary/LeverandorSummaryView';
import { LeverandorAccess } from '@klp/leverandor/index';

export interface FrontpageCardItem {
    title: string;
    icon: IconName;
    dataTestId: string;
    content: React.ReactNode;
    isVisible: () => boolean;
}

export type FrontpageCard = Record<FrontpageCardTypes, FrontpageCardItem>;

interface CreateFrontpageCardsConfigParams {
    currentUser: Bruker | undefined;
    selectedContext: unknown;
}

export const createFrontpageCardsConfig = ({
    currentUser,
    selectedContext,
}: CreateFrontpageCardsConfigParams): FrontpageCard => ({
    [FrontpageCardTypes.AREALMESSIG_UTLEIEGRAD]: {
        title: 'frontPage.expiredContracts.areaRatio',
        icon: IconName.PIGGY_BANK,
        dataTestId: 'DashboardButtonExpiringContracts',
        content: currentUser && <ArealmessigUtleiegradSummary />,
        isVisible: () => Boolean(currentUser),
    },
    [FrontpageCardTypes.KONTRAKTER]: {
        title: 'frontPage.contractManagement.title',
        icon: IconName.DOCUMENTS,
        dataTestId: 'Kontrakter',
        content: <ContractManagementSummaryView />,
        isVisible: () => ContractManagementRegistrationAccess(),
    },
    [FrontpageCardTypes.PROSJEKTER]: {
        title: 'frontPage.project.title',
        icon: IconName.DOC_INBOUND,
        dataTestId: 'Prosjekt',
        content: <ProsjektSummaryView />,
        isVisible: () => true,
    },
    [FrontpageCardTypes.UTESTAAENDE_FORDRINGER]: {
        title: 'frontPage.utestaaendeFordringer.title',
        icon: IconName.CIRCLE_OBS,
        dataTestId: 'DashboardButtonLatePayments',
        content: <UtestaaendeFordringerSummary />,
        isVisible: () => true,
    },
    [FrontpageCardTypes.SAKER]: {
        title: 'frontPage.sak.title',
        icon: IconName.DOCUMENTS,
        dataTestId: 'Sak',
        content: <SakSummaryView />,
        isVisible: () => Boolean(selectedContext),
    },
    [FrontpageCardTypes.LEVERANDOR]: {
        title: 'frontPage.leverandor.title',
        icon: IconName.DOC_INTERNAL,
        dataTestId: 'Leverandor',
        content: <LeverandorSummaryView />,
        isVisible: () => LeverandorAccess(currentUser),
    },
});
